import React from "react"

const ModalOverlay = ({onClick}) => {
  return (
    <div id="modalOverlay" onClick={onClick}></div>
  )
}

export default ModalOverlay